import { Trash2 } from 'lucide-react';

function ClearFieldButton({ visible, onClick }) {
  if (!visible) return null;
  return (
    <button type="button" onClick={onClick} tabIndex={-1}
      className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-0.5 text-zinc-600 transition-colors hover:text-red-400"
      aria-label="Effacer">
      <Trash2 className="h-3.5 w-3.5" />
    </button>
  );
}

export function CrawlCredentialFields({ username, setUsername, password, setPassword, crawling }) {
  return (
    <>
      <div className="space-y-2">
        <label htmlFor="username" className="text-sm font-medium">Identifiant</label>
        <div className="relative">
          <input id="username" data-testid="crawl-username-input" type="text" value={username}
            onChange={(event) => setUsername(event.target.value)} placeholder="Nom d'utilisateur ou email" disabled={crawling}
            className="h-10 w-full rounded-sm border border-zinc-800 bg-zinc-900/50 px-4 pr-8 text-white placeholder:text-zinc-600 transition-colors duration-300 focus:border-white focus:outline-none focus:ring-0" />
          <ClearFieldButton visible={username.length > 0} onClick={() => setUsername('')} />
        </div>
      </div>
      <div className="space-y-2">
        <label htmlFor="password" className="text-sm font-medium">Mot de passe</label>
        <div className="relative">
          <input id="password" data-testid="crawl-password-input" type="password" value={password}
            onChange={(event) => setPassword(event.target.value)} placeholder="Mot de passe" disabled={crawling}
            className="h-10 w-full rounded-sm border border-zinc-800 bg-zinc-900/50 px-4 pr-8 text-white placeholder:text-zinc-600 transition-colors duration-300 focus:border-white focus:outline-none focus:ring-0" />
          <ClearFieldButton visible={password.length > 0} onClick={() => setPassword('')} />
        </div>
      </div>
      <p className="text-xs text-yellow-600">L'authentification automatique peut échouer avec certains SSO ou parcours 2FA.</p>
    </>
  );
}
